import {useTheme} from "@mui/material";
import {PropsWithChildren} from "react";

export function TagItem(props: PropsWithChildren<{
    color: string;
}>) {
    const theme = useTheme();
    return (
        <div style={{
            backgroundColor: props.color,
            color: theme.palette.getContrastText(props.color || "#fff"),
            fontWeight: "bold",
            borderRadius: 4,

            paddingTop: 4,
            paddingLeft: 6,
            paddingRight: 6,
            paddingBottom: 3,
            height: "auto",
            alignSelf: "center",
            lineHeight: "1em",

            display: "block",
            flex: 0,
            fontSize: "0.75rem",
        }}>
            {props.children}
        </div>
    )
}